import { dayjs } from '@shared/utils';
import { UserStatus } from '@user-management/user-details';

import type { UsBoUser } from '../../../types';

function mapStatus(status: string | null, invitationExpireAt: string | null) {
  if (status === null) {
    throw new Error('Status is required');
  }
  if (status === 'INVITATION_PENDING' && dayjs(invitationExpireAt).isBefore(dayjs())) {
    return UserStatus.INVITATION_EXPIRED;
  }
  return status as UserStatus;
}

export function mapper(users?: UsBoUser[]) {
  if (!users) return [];
  return users.map((user) => ({
    id: user.id,
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email,
    status: mapStatus(user.status, user.invitationExpireAt),
    appRoles: user.appRoles,
    createdAt: user.createdAt,
    updatedAt: user.updatedAt,
    lastLoginAt: user.lastLoginAt,
  }));
}
